<template>
  <div class="container page" style="width: 100%;">
    <van-nav-bar :title="$t('my.task_record')" class="nav-bar">
      <template #left>
        <van-icon name="arrow-left" color="#fff" @click="back()" />
      </template>
    </van-nav-bar>

    <div class="main">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-empty v-if="list.length === 0" :description="$t('withdraw.empty_data')" />

        <div v-else class="item_list" v-for="(v, key) in list" :key="key">
          <div class="lottery_info">
            <span class="period-number">{{ v.expect }}</span>
            <span class="period-number">{{ v.name }}</span>
          </div>

          <div class="recent">
            <div class="result-container">
              <span class="result-label">{{ $t("reservation.result") }}</span>
              <div v-if="resultOptions(v).length" class="badges-wrapper">
                <span v-for="result in resultOptions(v)" :key="result" class="result-icon">
                  <img :src="resultImage(result)" alt="" />
                </span>
              </div>
              <span v-else class="pending-result">--</span>
            </div>
          </div>

          <div class="my-votes">
            <span class="result-label">我的投票</span>
            <div class="vote-items">
              <div v-for="(vote, voteIndex) in voteOptions(v)" :key="vote.type + '-' + voteIndex" class="vote-item">
                <img :src="resultImage(vote.icon)" alt="" />
                <b>×{{ vote.money }}</b>
              </div>
            </div>
          </div>

          <div class="topInfo">
            <span v-if="v.status === 1" style="color: #07c160">{{ v.status_text }}</span>
            <span v-else>{{ v.status_text }}</span>
            <span class="money-text">{{ $t("reservation.money") }}：{{ v.money }}</span>
          </div>
          <div class="time">
            <span>{{ $t("reservation.order_time") }}：{{ v.create_time }}</span>
          </div>
          <div class="time">
            <span>{{ $t("reservation.settle_time") }}：{{ v.update_time }}</span>
          </div>
        </div>
      </van-pull-refresh>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isLoading: false,
      list: [],
    };
  },
  methods: {
    back() {
      return window.history.back();
    },
    onRefresh() {
      setTimeout(() => {
        this.$toast(this.$t("reservation.refresh"));
        this.isLoading = false;
        this.getUserGameList();
      }, 500);
    },
    resultOptions(item) {
      if (!item || item.opencode === undefined || item.opencode === null || item.opencode === '') return [];
      const values = Array.isArray(item.opencode)
        ? item.opencode
        : String(item.opencode).split(',');
      const validValues = values.filter(value => value !== '' && !Number.isNaN(Number(value)));
      if (!validValues.length) return [];
      const sum = validValues.reduce((total, value) => total + Number(value), 0);
      return [sum >= 11 ? 'rose' : 'yacht', sum % 2 === 0 ? 'heart' : 'rocket'];
    },
    resultImage(result) {
      return '/img/certification/' + result + '.png';
    },
    voteOptions(item) {
      const iconMap = { big: 'rose', small: 'yacht', one: 'heart', two: 'rocket' };
      const details = Array.isArray(item && item.data) ? item.data : [];
      return details
        .filter(detail => iconMap[String(detail.type || '').toLowerCase()])
        .map(detail => ({
          type: String(detail.type || '').toLowerCase(),
          icon: iconMap[String(detail.type || '').toLowerCase()],
          money: detail.money
        }));
    },
    getUserGameList() {
      this.$http({
        method: 'get',
        url: 'user_get_game_list'
      }).then(res => {
        if (res.code === 200) {
          this.list = res.data;
        } else if (res.code === 401) {
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' })
    } else {
      this.getUserGameList();
    }
  },
};
</script>

<style lang='less' scoped>
@import "../../assets/css/base.css";

::v-deep .van-pull-refresh__track .van-pull-refresh__head * {
  color: #000000;
  font-size: 35px;
}

::v-deep .van-loading__text {
  color: #000000;
  font-size: 35px;
}

.container .main {
  position: relative;
  overflow: auto;
  background-color: #f2f2f5;
  height: 100%;
  padding: 0 10px;
}

.item_list {
  padding: 15px 15px;
  margin: 30px 10px;
  background: #fff;
  border-radius: 10px;
  line-height: 60px;
}

.item_list .topInfo span {
  flex: 1;
  font-size: 32px;
  font-weight: 700;
  color: #000;
}

.item_list .money-text {
  margin-left: 20px;
}

.item_list .time span {
  flex: 1;
  font-size: 25px;
  font-weight: 500;
  color: #000;
}

.item_list .period-number {
  margin-left: 20px;
  margin-right: 10px;
  font-size: 35px;
  font-weight: 700;
  color: #000;
}

.item_list .lottery_info {
  display: flex;
}

/* 修复后的布局样式 */
.recent {
  display: flex;
  align-items: center;
  padding: 10px 0;
}

.result-container {
  display: flex;
  align-items: center;
}

.result-label {
  font-size: 28px;
  color: #333;
  margin-right: 15px;
  font-weight: 500;
}

.badges-wrapper {
  display: flex;
  align-items: center;
}

.result-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 74px;
  height: 74px;
  margin-right: 16px;
  overflow: hidden;
  border-radius: 16px;
  background: #f7f3fb;
}

.result-icon img {
  width: 62px;
  height: 62px;
  object-fit: contain;
}

.pending-result {
  color: #999;
  font-size: 28px;
}

.my-votes {
  display: flex;
  align-items: center;
  padding: 8px 0 14px;
}

.vote-items {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 14px;
}

.vote-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 7px 14px 7px 8px;
  border-radius: 16px;
  background: #f7f3fb;
}

.vote-item img {
  width: 54px;
  height: 54px;
  object-fit: contain;
}

.vote-item b {
  color: #5b4eb9;
  font-size: 24px;
  line-height: 1;
}
</style>
